import type { RenameUserResponse } from "../../../api/clientUsersTypes";
import type { ExecutionState } from "../../../hooks/useExecutionState";

export const buildRenameUserMessage = (resp: RenameUserResponse, organizationName: string): ExecutionState => {
  const links = resp.businessCentralUrl
    ? [{ label: "Open the Business Central Users page", href: resp.businessCentralUrl }]
    : undefined;

  if (resp.directoryUpdated) {
    return {
      status: "success",
      text: "User renamed",
      details: [
        `Updated ${resp.displayName} (${resp.newEmail}) in ${organizationName} — name in every company, email, and sign-in email.`,
        "Updated the user in the client's Microsoft directory.",
        'Last step: open Business Central and click "Synchronize with Microsoft" on the Users page.',
      ],
      links,
    };
  }

  const manualValues = resp.directoryUserValues
    ? [
        "To finish by hand, open the user in the client's Microsoft directory and set:",
        `• Display name: ${resp.directoryUserValues.displayName}`,
        `• First name: ${resp.directoryUserValues.givenName}`,
        `• Last name: ${resp.directoryUserValues.surname}`,
        `• Email (mail): ${resp.directoryUserValues.mail}`,
        `• Mail nickname: ${resp.directoryUserValues.mailNickname}`,
        `• User principal name: ${resp.directoryUserValues.userPrincipalName}`,
      ]
    : [];

  return {
    status: "warning",
    text: "Updated partially",
    details: [
      `Updated ${resp.displayName} (${resp.newEmail}) in ${organizationName} — name in every company, email, and sign-in email.`,
      `The client directory was NOT updated: ${resp.directoryError ?? "unknown reason"}.`,
      ...manualValues,
    ],
    links,
  };
};
